/**
 * @generated SignedSource<<a27177b93fb057d1b4082a062e581e12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleDesignManager_user$data = {
  readonly tradeFirmDesignManagerProfile: {
    readonly accountType: string | null;
    readonly hasAccount: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TradeDesignManagerModal_user" | "TradeOnboardingCoachmarkConditionalLoader_user">;
  readonly " $fragmentType": "PdpRespIconBubbleDesignManager_user";
};
export type PdpRespIconBubbleDesignManager_user$key = {
  readonly " $data"?: PdpRespIconBubbleDesignManager_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleDesignManager_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleDesignManager_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmDesignManagerProfileType",
      "kind": "LinkedField",
      "name": "tradeFirmDesignManagerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasAccount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeDesignManagerModal_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "215cd72b6910597d7e81b09498479e77";

export default node;
